import { Component } from '@angular/core';

@Component({
  selector: 'demo-dropdown-trigger-by-isopen',
  templateUrl: './trigger-by-isopen-property.html'
})
export class DemoDropdownByIsOpenPropComponent {
}
